import i18n from "../../i18n";
import React from "react";
import { Tabs, Text, Group, Button, Stack } from "@mantine/core";
import { Page } from "../../layout/page";
import ExtraFieldListEditor from "../../components/extraField/ExtraFieldListEditor";

function ExtraFields() {
  return (
    <Page hideTitle>
      <Tabs defaultValue="user" keepMounted={false}>
        <Tabs.List>
          <Tabs.Tab value="user">{i18n.t("User")}</Tabs.Tab>
          <Tabs.Tab value="client">{i18n.t("Client")}</Tabs.Tab>
          <Tabs.Tab value="order">{i18n.t("Order")}</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="user" mt="md">
          <ExtraFieldListEditor entityType="User" />
        </Tabs.Panel>
        <Tabs.Panel value="client" mt="md">
          <ExtraFieldListEditor entityType="Client" />
        </Tabs.Panel>
        <Tabs.Panel value="order" mt="md">
          <ExtraFieldListEditor entityType="Order" />
        </Tabs.Panel>
      </Tabs>
    </Page>
  );
}

export default ExtraFields;
